
  import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
  import {
    Getter,
  } from 'vuex-class';
  import Generator from '@/components/Admin/Generator.vue';

  @Component({
    components: {
      Generator,
    },
  })
  export default class GeneratorDialog extends Vue {
    public $refs!: {
      form: any,
      generator: any,
    };
    @Prop({type: Object, default: null}) private template!: any;
    @Prop({type: Array, default: () => []}) private elements!: any;
    @Prop({type: Boolean, default: false}) private icon!: boolean;

    @Getter('common/rules/all') private rules!: any;

    private localTemplate: any = {};
    private dialog: boolean = false;
    private loading: boolean = false;

    private localElements: any = [];
    private content: any = {};

    private save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$emit('save', {
          title: this.localTemplate.title,
          subject: this.localTemplate.subject,
          id: this.template ? this.template.id : null,
          ...this.content,
        });
        this.dialog = false;
        this.loading = false;
      }
    }

    private mounted() {
      if (this.template) {
        this.localTemplate = JSON.parse(JSON.stringify(this.template));
      }
      this.localElements = JSON.parse(JSON.stringify(this.elements));
    }

    private updateTemplate(data) {
      this.$emit('update', data);
      this.content = data;
    }

    @Watch('elements')
    private updateElements() {
      this.localElements = JSON.parse(JSON.stringify(this.elements));
    }

    private startLoading() {
      this.loading = true;
    }

    private stopLoading() {
      this.loading = false;
    }

  }
